<template>
  <!-- <g-pdf v-if="pdfAparecer"  :pdfFloat="false" :NovaGuia="true"> -->
  <div class="card-pdf-pedido-final">
    <g-card class="card-principal" :temCabecalho="false" :expansivel="false" margem="0" paddingDefault="0">
      <div class="informacoes-pdf-pedido-final">
        <div class="container-principal-gerador-paginas">
          <div class="content-grupo informacoes-pedido">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"></div>
                <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
              </div>
            </div>

            <div class="content-info-pedido grupo">
              <div class="container">
                <div class="grupo-pedido conteudo-grupo">
                  <div class="unidade-representante">
                    <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{PedidoArray.nomeRepresentante}}</div></div>
                    <div class="titulo-conteudo-cabecalho"> Unidade: &nbsp; <div class="label-cabecalho">{{PedidoArray.nome}}</div></div>
                  </div>

                  <div class="detalhes-pedido conteudo">
                    <div class="borda-titulo-grupo titulo-detalhes-pedido">
                      <div class="titulo-grupo"> DETALHES DO PEDIDO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-detalhes-pedido">
                      <div class="pedido">
                        <div class="titulo-conteudo-detalhes"> Pedido </div>
                        <div class="label-conteudo">{{PedidoArray.codigoExterno}}</div>
                      </div>

                      <div class="orcamento">
                        <div class="titulo-conteudo-detalhes"> Orçamento </div>
                        <div class="label-conteudo">{{PedidoArray.numeroDaSolicitacao}}</div>
                      </div>

                      <div class="cliente-cnpj">
                        <div class="titulo-conteudo-detalhes"> Cliente/CNPJ </div>
                        <div class="label-conteudo">{{PedidoArray.nomeFantasia}} / {{PedidoArray.cnpj}}</div>
                      </div>

                      <div class="cv">
                        <div class="titulo-conteudo-detalhes"> CV </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="unidade">
                        <div class="titulo-conteudo-detalhes"> Unidade </div>
                        <div class="label-conteudo">{{PedidoArray.nome}}</div>
                      </div>

                      <div class="representante">
                        <div class="titulo-conteudo-detalhes"> Representante </div>
                        <div class="label-conteudo">{{PedidoArray.nomeRepresentante}}</div>
                      </div>

                      <div class="tipo">
                        <div class="titulo-conteudo-detalhes"> Tipo </div>
                        <div class="label-conteudo"></div>
                      </div>
                    </div>
                  </div>

                  <div class="dados-pedido conteudo">
                    <div class="borda-titulo-grupo titulo-dados-pedido">
                      <div class="titulo-grupo"> DADOS DO PEDIDO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-dados-pedido">
                      <div class="status">
                        <div class="titulo-conteudo-detalhes"> Status </div>
                        <div class="label-conteudo">{{PedidoArray.statusPedidoTexto}}</div>
                      </div>

                      <div class="programacao-kanban">
                        <div class="titulo-conteudo-detalhes"> Programação Kanban </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <!-- <div class="comissao-repr">
                        <div class="titulo-conteudo-detalhes"> Comissão Repr. </div>
                        <div class="label-conteudo"></div>
                      </div> -->

                      <div class="preco">
                        <div class="titulo-conteudo-detalhes"> Preço </div>
                        <div class="label-conteudo"> R$ {{PedidoArray.valorUnitario}}</div>
                      </div>

                      <div class="transportadora">
                        <div class="titulo-conteudo-detalhes"> Transportadora </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="digitacao">
                        <div class="titulo-conteudo-detalhes"> Digitação </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="codigo-acesso">
                        <div class="titulo-conteudo-detalhes"> Código de Acesso </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="exportacao">
                        <div class="titulo-conteudo-detalhes"> Exportação </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="precoTot-sem-ipi">
                        <div class="titulo-conteudo-detalhes"> Preço Total Sem IPI </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="papel-seda">
                        <div class="titulo-conteudo-detalhes"> Papel Seda </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="frete-cidade">
                        <div class="titulo-conteudo-detalhes"> Frete/Cidade </div>
                        <div class="label-conteudo">{{PedidoFreteArray.indicadorDeTipoFreteoEnum}} / {{PedidoFreteArray.nomeCidade}}</div>
                      </div>

                      <div class="comissao-venda">
                        <div class="titulo-conteudo-detalhes"> Comissão Venda </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="condicao-pagto">
                        <div class="titulo-conteudo-detalhes"> Condição Pagamento </div>
                        <div class="label-conteudo">{{PedidoArray.formaDePagamento}}</div>
                      </div>

                      <div class="qtd-total">
                        <div class="titulo-conteudo-detalhes"> Qtd. Total </div>
                        <div class="label-conteudo">{{PedidoArray.quantidadeProdutoNovo}}</div>
                      </div>                    
                    </div>
                  </div>

                  <div class="caracteristicas-pedido conteudo">
                    <div class="borda-titulo-grupo titulo-caracts-pedido">
                      <div class="titulo-grupo"> CARACTERÍSTICAS DO PEDIDO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-caracts-pedido">
                      <div class="impressao">
                        <div class="titulo-conteudo-detalhes"> Impressão </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="visual">
                        <div class="titulo-conteudo-detalhes"> Visual </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="faca-sistema">
                        <div class="titulo-conteudo-detalhes"> Faca Sistema </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="faca-medida">
                        <div class="titulo-conteudo-detalhes"> Faca Medida </div>
                        <div class="label-conteudo"></div>
                      </div>
                    </div>
                  </div>                
                </div>
              </div>
            </div>
          </div>

          <div class="html2pdf__page-break"/>

          <div class="content-grupo informacoes-produto">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"></div>
                <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, 11 de julho de 2023 </div> <!-- Jaú, {{ this.DiaHoje }} -->
                <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
              </div>
            </div>

            <div class="content-info-produto grupo">
              <div class="container">
                <div class="grupo-produto conteudo-grupo">
                  <div class="info-produto">
                    <div class="borda-titulo-grupo titulo-dados-pedido">
                      <div class="titulo-grupo"> PRODUTO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-info-produto">
                      <div class="produto">
                        <div class="titulo-conteudo-detalhes"> Produto </div>
                        <div class="label-conteudo">{{PedidoArray.codigoExternoProdutoNovo}} - {{PedidoArray.nomeProduto}}</div>
                      </div>

                      <div class="data-ultimo-faturamento">
                        <div class="titulo-conteudo-detalhes"> Data do Último Faturamento </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="data-ultima-venda">
                        <div class="titulo-conteudo-detalhes"> Data da Última Venda </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="porcentagem-ipi">
                        <div class="titulo-conteudo-detalhes"> Porcentagem do IPI </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="produto-linha">
                        <div class="titulo-conteudo-detalhes"> Produto está em linha? </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="produto-selo-fsc">
                        <div class="titulo-conteudo-detalhes"> Produto possui selo FSC? </div>
                        <div class="label-conteudo"> ICMS: {{ PedidoArray.getICMS }} - IPI: {{ PedidoArray.getIPI }} - Pis/Cofins: {{ PedidoArray.getPisCofins }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="observacoes-produto">
                    <div class="borda-titulo-grupo titulo-obs-produto">
                      <div class="titulo-grupo"> OBSERVAÇÕES </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-obs-produto">
                      <div class="observacoes-produto">
                        <div class="titulo-conteudo-detalhes"> Observações da Impressão, Visual, Faca Sistema e Faca Medida </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="critica-processo">
                        <div class="titulo-conteudo-detalhes"> Crítica ao processo </div>
                        <div class="label-conteudo"></div>
                      </div>
                    </div>
                  </div>       
                </div>
              </div>
            </div>
          </div>

          <div class="html2pdf__page-break"/>

          <div class="content-grupo informacoes-componentes">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"></div>
                <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, 11 de julho de 2023 </div> <!-- Jaú, {{ this.DiaHoje }} -->
                <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
              </div>
            </div>

            <div class="content-info-componentes grupo">
              <div class="container-componentes">
                <div class="borda-titulo-grupo titulo-componentes">
                  <div class="titulo-grupo"> COMPONENTES </div>
                  <div class="borda-grupo"></div>
                </div>

                <div class="grupo-componentes"></div>
              </div>
            </div>
          </div>

          <div class="html2pdf__page-break"/>

          <div class="content-grupo informacoes-parcelas">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"></div>
                <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, 11 de julho de 2023 </div> <!-- Jaú, {{ this.DiaHoje }} -->
                <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
              </div>
            </div>

            <div class="content-info-parcelas grupo">
              <div class="container-parcelas">
                <div class="borda-titulo-grupo titulo-parcelas">
                  <div class="titulo-grupo"> PARCELA(S) </div>
                  <div class="borda-grupo"></div>
                </div>

                <div class="grupo-parcelas">
                  <div class="parcelas" v-for="(parcela, index) in quantidadeParcelaArray" :key="parcela.id">
                    <div class="numero-parcela"> {{index + 1}}º Parcela </div>
                    <div class="conteudo-parcelas">
                      <div class="data-carregamento">
                        <div class="titulo-conteudo-detalhes"> Data Carregamento </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="data-conf-carregamento">
                        <div class="titulo-conteudo-detalhes"> Data Conf. Carregamento </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="qtde-produzida">
                        <div class="titulo-conteudo-detalhes"> Quantidade Produzida </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="qtde-expedida">
                        <div class="titulo-conteudo-detalhes"> Quantidade Expedida </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="parcela">
                        <div class="titulo-conteudo-detalhes"> Parcela </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="agua-liberacao-producao">
                        <div class="titulo-conteudo-detalhes"> Aguardando Liberação para Produzir </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="dias-prorrogados">
                        <div class="titulo-conteudo-detalhes"> Dias Prorrogados </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="indicador">
                        <div class="titulo-conteudo-detalhes"> Indicador </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="data-base">
                        <div class="titulo-conteudo-detalhes"> Data Base </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="ordem-compra">
                        <div class="titulo-conteudo-detalhes"> Ordem de Compra </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="componente">
                        <div class="titulo-conteudo-detalhes"> Componente </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="fase-producao">
                        <div class="titulo-conteudo-detalhes"> Fase de Produção </div>
                        <div class="label-conteudo"></div>
                      </div>

                      <div class="obs-parcelas">
                        <div class="titulo-conteudo-detalhes"> Observações sobre as parcelas </div>
                        <div class="label-conteudo"></div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  

      <div class="html2pdf__page-break"/>


      

        <div class="espacamento-pdf">
        <div class="titulo-grupo-detalhes"> ORÇAMENTO </div>
        <div class="grupo-orcamento">
          <div class="orcamento-numero-solicitacao">
            <div class="titulo-conteudo-resumo-final"> Nº Solicitação </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroDaSolicitacao}} </div>
          </div>

          <div class="orcamento-data-digitacao">
            <div class="titulo-conteudo-resumo-final"> Dt. de Digitação </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.dataDigitacaoFormatada}} </div>
          </div>

          <div class="orcamento-razao-social">
              <div class="titulo-conteudo-resumo-final"> Razão Social </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.razaoSocialCliente}} </div>
          </div>

          <div class="orcamento-nome-produto">
              <div class="titulo-conteudo-resumo-final"> Nome do Produto </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExternoProdutoNovo}} - {{PedidoArray.nomeProduto}} </div>
          </div>

          <div class="orcamento-status">
            <div class="titulo-conteudo-resumo-final"> Status </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.statusPedidoTexto}} </div>
          </div>

          <div class="orcamento-cliente">
              <div class="titulo-conteudo-resumo-final"> Cliente </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeFantasia}} </div>
          </div>

          <div class="orcamento-unidade">
              <div class="titulo-conteudo-resumo-final"> Unidade </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.nome}} </div>
          </div>

          <div class="orcamento-representante">
              <div class="titulo-conteudo-resumo-final"> Representante </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeRepresentante}} </div>
          </div>
        </div>
        <div class="titulo-grupo-detalhes"> CLIENTE </div>
        <div class="grupo-cliente">
          <div class="cliente-cnpj">
            <div class="titulo-conteudo-resumo-final"> CNPJ </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.cnpj}} </div>
          </div>

          <div class="cliente-codigo">
            <div class="titulo-conteudo-resumo-final"> Código </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExt}} </div>
          </div>

          <div class="cliente-razao-social">
            <div class="titulo-conteudo-resumo-final"> Razão Social</div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.razaoSocialCliente}} </div>
          </div>

          <div class="cliente-estado">
            <div class="titulo-conteudo-resumo-final"> Estado </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeEstado}} </div>
          </div>

          <div class="cliente-cidade">
            <div class="titulo-conteudo-resumo-final"> Cidade </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeCidade}} </div>
          </div>

          <div class="cliente-segmento">
            <div class="titulo-conteudo-resumo-final"> Segmento </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.indicadorSegmentoEnum}} </div>
          </div>

          <div class="cliente-contato">
            <div class="titulo-conteudo-resumo-final"> Contato </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.emailNFE}} </div>
          </div>

          <div class="cliente-telefone">
            <div class="titulo-conteudo-resumo-final"> Telefone </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroTelefone}} </div>
          </div>

          <div class="cliente-ramal">
            <div class="titulo-conteudo-resumo-final"> Ramal </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroDDDFax}} </div>
          </div>

          <div class="cliente-suframa">
            <div class="titulo-conteudo-resumo-final"> Suframa </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroSuframa}} </div>
          </div>

          <div class="cliente-incentivo-fiscal">
            <div class="titulo-conteudo-resumo-final"> Possui incentivo fiscal? </div>
            <div class="label-conteudo-resumo-final"> ICMS: {{ PedidoArray.getICMS }} - IPI: {{ PedidoArray.getIPI }} - Pis/Cofins: {{ PedidoArray.getPisCofins }} </div>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> FRETE </div>
        <div class="grupo-frete">
          <div class="grupoFrete-frete">
            <div class="titulo-conteudo-resumo-final"> Frete </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.indicadorDeTipoFreteoEnum}} </div>
          </div>

          <div class="frete-estado">
            <div class="titulo-conteudo-resumo-final"> Estado </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeEstado}} </div>
          </div>

          <div class="frete-cidade">
            <div class="titulo-conteudo-resumo-final"> Cidade </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeCidade}} </div>
          </div>

          <div class="frete-transportadora">
            <div class="titulo-conteudo-resumo-final"> Transportadora </div>
            <div class="label-conteudo-resumo-final">  </div>
          </div>

          <div class="frete-endereco">
            <div class="titulo-conteudo-resumo-final"> Endereço </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeEndereco}} </div>
          </div>

          <div class="frete-cep">
            <div class="titulo-conteudo-resumo-final"> CEP </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.cep}} </div>
          </div>

          <div class="frete-bairro">
            <div class="titulo-conteudo-resumo-final"> Bairro </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.bairro}} </div>
          </div>

          <div class="frete-complemento">
            <div class="titulo-conteudo-resumo-final"> Complemento </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.complemento}} </div>
          </div>
        </div>

        <div class="html2pdf__page-break"/>

        <div class="titulo-grupo-detalhes"> PRODUTO </div>
        <div class="grupo-produto">
          <div class="grupoProduto-produto">
            <div class="titulo-conteudo-resumo-final"> Produto </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExternoProdutoNovo}} - {{PedidoArray.nomeProdutoNovo}} </div>
          </div>

          <div class="grupoProduto-codigo-produto">
            <!-- <div class="titulo-conteudo-resumo-final"> Código do Produto </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExternoProdutoNovo}} </div> -->
          </div>

          <!-- <div class="produto-tipo-acesso">
            <div class="titulo-conteudo-resumo-final"> Tipo de Acesso </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoAcesso}} </div>
          </div> -->

          <div class="produto-condicao-pagamento">
            <div class="titulo-conteudo-resumo-final"> Condição de Pagamento </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.formaDePagamento}} </div>
          </div>

          <div class="produto-quantidade-total">
            <div class="titulo-conteudo-resumo-final"> Quantidade Total </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.quantidadeProdutoNovo}} </div>
          </div>

          <div class="produto-unitario">
            <div class="titulo-conteudo-resumo-final"> Unitário </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.valorUnitario}} </div>
          </div>

          <div class="produto-preco-total">
            <div class="titulo-conteudo-resumo-final"> Preço Total sem IPI </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.precoTotalSemIPI}} </div>
          </div>
    
        </div>
        <div class="titulo-grupo-detalhes"> PARCELA(S) </div>
          <div class="vfor-quantidadeParcela" :key="parcela.id" v-for="parcela in quantidadeParcelaArray">
            <div class="grupoProduto-numero-parcela">
              <div class="titulo-conteudo-resumo-final">Parcela</div>
              <div class="label-conteudo-resumo-final"> {{parcela.numeroParcela}} </div>
            </div>

            <div class="grupoProduto-data-entrega">
              <div class="titulo-conteudo-resumo-final"> Data de Entrega </div>
              <div class="label-conteudo-resumo-final"> {{parcela.dataPedidoParcelaFormatada}} </div>
            </div>
            <div class="grupoProduto-data-entrega">
              <div class="titulo-conteudo-resumo-final"> Quantidade </div>
              <div class="label-conteudo-resumo-final"> {{parcela.quantidadePedidoParcela}} </div>
            </div>
          </div>
      </div>

    </g-card>
  </div>
</template>
  
<script>
import PDFPedidoFinal from './PDFPedidoFinal.js'
export default PDFPedidoFinal
</script>
  
<style scoped>
.card-pdf-pedido-final {
  font-family: 'MontSerrat';
}

.content-grupo {
  position: relative;
  height: 100%;
}

.template-pagina {
  position: absolute;
  height: 70.125rem;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1000;
}

.imagem-template-cabecalho {
  display: flex;
  align-items: flex-start;
}
.imagem-template-rodape {
  position: relative;
  display: flex;
  align-items: flex-end;
}

.img-cabecalho, .img-rodape {
  width: 99.25%;
}

.espaco-data-rodape {
  position: relative;
}
.data-rodape {
  color: #fff !important;
  font-size: 0.75rem !important;
  font-weight: 500;
  position: absolute;
  height: 100%;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  padding: 0.35rem 1.5rem 0.3rem 0;
  z-index: 1000;
}

.grupo {
  position: absolute;
  padding: 6.5rem 2rem 0;
  width: 99.25%;
}

.borda-titulo-grupo {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
}

.borda-grupo {
  width: 5rem;
  height: 3px;
  background-color: #FCB315;
}

.titulo-grupo {
  width: 100%;
  color: #4f2c19;
  text-align: left;
  font-size: 1.1rem;
  font-family: "MontSerrat";
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.titulo-conteudo-detalhes {
  color: #3f3f3f;
  font-size: 0.8rem;
  margin-top: 0.1rem;
}
.label-conteudo {
  font-size: 0.8rem;
}

.unidade-representante {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.conteudo-grupo {
  width: 99.25%;
  display: flex;
  flex-direction: column;
  row-gap: 3.5rem;
}

.conteudo {
  padding: 1rem;
}

.conteudo-detalhes-pedido,
.conteudo-dados-pedido,
.conteudo-caracts-pedido {
  display: grid;
  grid-template-columns: repeat(3, 1fr) max-content;
  column-gap: 1rem;
}

.conteudo-info-produto, .conteudo-parcelas {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}
</style>